export enum SituacaoNota {
  Nova = 'nova',
  Obsoleta = 'obsoleta',
  Pronta = 'pronta',
  Inconsistente = 'inconsistente',
  Parcial = 'parcial',
}

export enum NegocioBMF {
  Daytrade = 'DAY TRADE',
  Normal = 'NORMAL',
  Ajupos = 'AJUPOS',
}

export enum DebitoCredito {
  Debito = 'D',
  Credito = 'C',
}

export enum Mercado {
  A_VISTA = 'Vista',
  FUTUROS = 'Futuros',
  OPCOES = 'Opções',
  EXERCICIO_OPCOES = 'Exercício de Opções',
}

export enum Negociacao {
  BOVESPA = 'Bovespa',
  BMF = 'BMF',
}

export enum TipoOperacao {
  COMPRA = 'C',
  VENDA = 'V',
}

export enum ClasseAtivo {
  DIREITO = 'DIREITO',
  FII = 'FII',
  FIAGRO = 'FIAGRO',
  FI_INFRA = 'FI INFRA',
  FIP_IE = 'FIP IE',
  FIP_MULTI = 'FIP MULTI',
  ACAO = 'AÇÃO',
  OPCAO = 'OPÇÃO',
  BDR = 'BDR',
  ETF = 'ETF',
  ETF_RF = 'ETF RENDA FIXA',
  DOLAR = 'DÓLAR',
  INDICES = 'ÍNDICES',
  JUROS = 'JUROS',
  OUTROS = 'OUTROS',
}

export enum TipoEvento {
  AMORTIZACAO = 'AMORTIZAÇÃO',
  DESDOBRAMENTO = 'DESDOBRAMENTO DE AÇÕES',
  DIVIDENDO = 'DIVIDENDO',
  GRUPAMENTO = 'GRUPAMENTO',
  INCORPORACAO = 'INCORPORAÇÃO',
  JUROS = 'JUROS SOBRE CAPITAL PRÓPRIO',
  RENDIMENTO = 'RENDIMENTO',
  ATUALIZACAO = 'ATUALIZACAO',
  CISAO = 'CISÃO COM RED. DE CAPITAL',
  SUBSCRICAO_DISTRIBUICAO = 'DISTRIBUIÇÃO DE SUBSCRIÇÃO',
  SUBSCRICAO_EXERCICIO = 'EXERCÍCIO DE SUBSCRIÇÃO',
  BONIFICACAO = 'BONIFICAÇÃO EM ATIVOS',
  RESTITUICAO_ACOES = 'RESTITUIÇÃO CAPITAL EM AÇÕES',
  DISSOLUCAO = 'DISSOLUÇÃO',
  LIQUIDACAO = 'LIQUIDAÇÃO',
}

export enum Trade {
  Daytrade = 'DT',
  Swingtrade = 'ST',
}

export enum SituacaoUpload {
  PENDENTE = 'pendente',
  SALVO = 'salvo',
  IMPORTADO = 'importado',
  ERRO_AO_LER = 'erro_ao_ler',
  ERRO_AO_IMPORTAR = 'erro_ao_importar',
}

export enum TipoUpload {
  CEI = 'informativo_cei',
  NEGOCIACOES_B3 = 'relatorio_negociacoes_b3',
  MOVIMENTACOES_B3 = 'relatorio_movimentacoes_b3',
  POSICOES_B3 = 'relatorio_posicoes_b3',
  NOTA = 'nota_b3',
  JSON_KLAVI = 'json_klavi',
  JSON_PLUGGY = 'json_pluggy',
}

export enum TipoRemessa {
  Deposito = 'DEPOSITO',
  Saque = 'SAQUE',
}

export enum MotivosAtualizar {
  NOTAS_APAGADAS = 'notas_apagadas',
  NOTAS_CADASTRADAS = 'notas_cadastradas',
  POSICAO_CADASTRADA = 'posicao_cadastrada',
  EVENTOS_CADASTRADOS = 'eventos_cadastrados',
  EXERCICIOS_CADASTRADOS = 'exercicios_cadastrados',
}

export enum StatusAssinatura {
  Teste = 'trialing',
  Ativa = 'active',
  Incompleta = 'incomplete',
  IncompletaExpirada = 'incomplete_expired',
  Vencida = 'past_due',
  Cancelada = 'canceled',
  NaoPaga = 'unpaid',
}

export enum SituacaoSincronizacao {
  CRIADA = 'criada',
  CONECTANDO = 'conectando',
  SINCRONIZANDO = 'sincronizando',
  ERRO_AO_SINCRONIZAR = 'erro',
  ERRO_AO_LER = 'erro_ao_ler',
  SINCRONIZADA = 'sincronizada',
  ATUALIZANDO = 'atualizando',
}

export enum TipoDocumento {
  CPF = 'br_cpf',
  CNPJ = 'br_cnpj',
}

export enum Role {
  ESSENTIAL = 'basic',
  BUSINESS = 'comercial',
}

export enum Perfil {
  INVESTIDOR = 'investidor',
  CONTADOR = 'contador',
}

export enum SituacaoCalculo {
  CALCULANDO = 'calculando',
  PRONTO = 'pronto',
  ERRO = 'erro',
}

export enum Parceiros {
  FENACON = 'FENACON',
  FELIX = 'FelixNaBolsa',
  VALLE = 'ValleConsultores',
  CONFERE_LEAO = 'ConfereLeao',
}

export enum LayoutPainel {
  GRADE = 'grade',
  LISTA = 'lista',
}

export enum Flags {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum OperacaoExtratoCredito {
  CREDITO = 'credito',
  DEBITO = 'debito',
}

/* Internacional */

export enum MoedaInternacional {
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  NOK = 'NOK',
  SEK = 'SEK',
  USD = 'USD',
}

export const isMoedaInternacional = (
  moeda: string,
): moeda is MoedaInternacional => {
  return Object.values(MoedaInternacional).includes(
    moeda as MoedaInternacional,
  );
};

export enum TipoOperacaoInternacional {
  BUY = 'BUY',
  SELL = 'SELL',
  INTEREST = 'INTEREST',
  DIVIDEND = 'DIVIDEND',
  OTHER = 'OTHER',
  // Evento corporativo (desdobramento/grupamento): ajusta quantidade e custo
  // médio sem caixa. Detalhe em OperacaoInternacional.evento.
  CORPORATE_ACTION = 'CORPORATE_ACTION',
  // Imposto retido na fonte no exterior sobre dividendo/juros: o "imposto
  // pago no exterior" da DIRPF, dedutível dos 15% por bem. Não é renda.
  WITHHOLDING_TAX = 'WITHHOLDING_TAX',
}

// Como uma opção saiu da carteira sem negociação em pregão (vem do parser da
// IB): EXERCICIO = exercida/designada (a opção encerra sem resultado e o prêmio
// vai para o custo/receita da ação entregue, marcada também); VENCIMENTO =
// expirou (encerra a zero e realiza o prêmio).
export enum LiquidacaoOpcao {
  EXERCICIO = 'EXERCICIO',
  VENCIMENTO = 'VENCIMENTO',
}

export const ROTULO_LIQUIDACAO_OPCAO: Record<LiquidacaoOpcao, string> = {
  [LiquidacaoOpcao.EXERCICIO]: 'exercício',
  [LiquidacaoOpcao.VENCIMENTO]: 'vencimento',
};

export enum TipoEventoInternacional {
  DESDOBRAMENTO = 'DESDOBRAMENTO',
  GRUPAMENTO = 'GRUPAMENTO',
  // Troca de ticker (ex.: FI → FISV): posição muda de código, custo e quantidade intactos.
  ALTERACAO_CODIGO = 'ALTERACAO_CODIGO',
}

export const ROTULO_EVENTO_INTERNACIONAL: Record<TipoEventoInternacional, string> = {
  [TipoEventoInternacional.DESDOBRAMENTO]: 'Desdobramento',
  [TipoEventoInternacional.GRUPAMENTO]: 'Grupamento',
  [TipoEventoInternacional.ALTERACAO_CODIGO]: 'Troca de ticker',
};
